webpackJsonp([1],{

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Start__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DateTime__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DateTime__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/:datetime?/:color?/:title?',
        name: 'Index',
        component: __WEBPACK_IMPORTED_MODULE_3__components_DateTime___default.a
    }, {
        path: '/old/:year?/:month?/:day?/:hour?/:minute?/:second?',
        name: 'Params',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Start___default.a
    }, {
        path: '/to/:datetime?/:color?/:title?',
        name: 'DateTime',
        component: __WEBPACK_IMPORTED_MODULE_3__components_DateTime___default.a
    }]
}));

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(152),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(123);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
    }
});

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'date-time',
    data: function data() {
        return {
            now: __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local(),
            height: 0,
            width: 0,
            defaultBackground: 'rebeccapurple'
        };
    },

    computed: {
        params: function params() {
            return this.$route.params;
        },
        targetDate: function targetDate() {
            if (!this.params.datetime) {
                return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local();
            }
            return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(this.params.datetime);
        },
        targetDateFormatted: function targetDateFormatted() {
            return this.targetDate.toFormat('DDDD tt');
        },
        duration: function duration() {
            if (this.now < this.targetDate) {
                return __WEBPACK_IMPORTED_MODULE_0_luxon__["Interval"].fromDateTimes(this.now, this.targetDate).toDuration(['years', 'months', 'days', 'hours', 'minutes', 'seconds']).toObject();
            }
            return false;
        },
        years: function years() {
            return this.duration.years;
        },
        months: function months() {
            if (!this.duration.months && this.duration.years) {
                return '00';
            }
            return this.zeroFill(this.duration.months);
        },
        days: function days() {
            if (!this.duration.days && (this.duration.years || this.duration.months)) {
                return '00';
            }
            return this.zeroFill(this.duration.days);
        },
        hours: function hours() {
            if (!this.duration.hours && (this.duration.years || this.duration.months || this.duration.days)) {
                return '00';
            }
            return this.zeroFill(this.duration.hours);
        },
        minutes: function minutes() {
            if (!this.duration.minutes && (this.duration.years || this.duration.months || this.duration.days || this.duration.hours)) {
                return '00';
            }
            return this.zeroFill(this.duration.minutes);
        },
        seconds: function seconds() {
            if (!Math.floor(this.duration.seconds) && (this.duration.years || this.duration.months || this.duration.days || this.duration.hours || this.duration.minutes)) {
                return '00';
            }
            return this.zeroFill(Math.floor(this.duration.seconds));
        },
        resolution: function resolution() {
            return this.width + 'x' + this.height;
        },
        bgColor: function bgColor() {
            var color = this.defaultBackground;
            if (this.params.color && this.params.color !== null && this.params.color !== 'null') {
                color = this.params.color;
                if (this.params.color.match(/[0-9A-F]{6}/i)) {
                    color = '#' + this.params.color;
                }
            }
            return color;
        },
        textColor: function textColor() {
            return this.getContrast50();
        },
        title: function title() {
            return this.params.title;
        },
        isLight: function isLight() {
            return this.getContrast50() === 'black';
        }
    },
    methods: {
        updateNow: function updateNow() {
            this.now = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local();
        },
        timer: function timer() {
            setInterval(this.updateNow, 100);
        },
        zeroFill: function zeroFill(num) {
            if (!num) {
                return;
            }
            if (num <= 9) {
                return '0' + num;
            }
            return num;
        },
        setBackground: function setBackground() {
            document.getElementsByTagName('body')[0].style.cssText = 'background-color: ' + this.bgColor + ';';
            this.getBackground();
            if (!this.getBackground()) {
                document.getElementsByTagName('body')[0].style.cssText = 'background-color: ' + this.defaultBackground + ';';
            }
        },
        getBackground: function getBackground() {
            var computedColor = window.getComputedStyle(document.body, null).getPropertyValue('background-color');
            var styleColor = document.getElementsByTagName('body')[0].style.backgroundColor;
            if (computedColor === 'rgba(0, 0, 0, 0)' || !styleColor) {
                return false;
            }
            return computedColor;
        },
        setText: function setText() {
            document.getElementsByTagName('body')[0].style.color = this.textColor;
        },
        getResolution: function getResolution() {
            this.height = document.body.clientHeight || document.documentElement.clientHeight || document.documentElement.scrollHeight;
            this.width = document.body.clientWidth || document.documentElement.clientWidth || document.documentElement.scrollWidth;
        },
        getContrast50: function getContrast50() {
            var color = window.getComputedStyle(document.body, null).getPropertyValue('background-color');
            color = color.match(/rgb\(([\d]*), ([\d]*), ([\d]*)\)/);
            var r = parseInt(color[1]);
            var g = parseInt(color[2]);
            var b = parseInt(color[3]);
            var yiq = (r * 299 + g * 587 + b * 114) / 1000;
            return yiq >= 128 ? 'black' : 'white';
        }
    },
    created: function created() {
        this.timer();
        document.title = 'countdown bis ' + this.targetDateFormatted;
        this.getResolution();
        window.addEventListener('resize', this.getResolution);
        this.setBackground();
        this.setText();
    }
});

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'start',
    data: function data() {
        return {
            years: null,
            months: null,
            days: null,
            hours: null,
            minutes: null,
            seconds: null,
            dateTime: '1998-07-16T19'
        };
    },

    computed: {
        params: function params() {
            return this.$route.params;
        },
        date: function date() {
            var year = parseInt(this.$route.params.year);
            var month = parseInt(this.$route.params.month);
            var day = parseInt(this.$route.params.day);
            var hour = parseInt(this.$route.params.hour);
            var minute = parseInt(this.$route.params.minute);
            var second = parseInt(this.$route.params.second);
            year = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(year) && year > 0 ? year : 1970;
            month = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(month) && month > 0 ? month - 1 : 0;
            day = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(day) && day > 0 ? day : 1;
            hour = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(hour) && hour > 0 ? hour : 0;
            minute = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(minute) && minute > 0 ? minute : 0;
            second = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(second) && second > 0 ? second : 0;
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()([year, month, day, hour, minute, second]);
        },
        dateReadable: function dateReadable() {
            return this.date.locale('de').format('LLLL');
        },
        splitDateTime: function splitDateTime() {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.dateTime).hours();
        }
    },
    methods: {
        timer: function timer() {
            var _this = this;

            setInterval(function () {
                var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
                var timerDate = _this.date.clone();

                if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(timerDate.diff(now)) <= 0) {
                    clearInterval(_this.timer);
                } else {
                    _this.years = Math.floor(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(timerDate.diff(now)).asYears());
                    _this.months = Math.floor(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(timerDate.subtract(_this.years, 'years').diff(now)).asMonths());
                    _this.days = Math.floor(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(timerDate.subtract(_this.months, 'months').diff(now)).asDays());
                    _this.hours = Math.floor(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(timerDate.subtract(_this.days, 'days').diff(now)).asHours());
                    _this.minutes = Math.floor(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(timerDate.subtract(_this.hours, 'hours').diff(now)).asMinutes());
                    _this.seconds = Math.floor(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(timerDate.subtract(_this.minutes, 'minutes').diff(now)).asSeconds());
                }
            }, 1000);
        },
        hasDuration: function hasDuration(value) {
            var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            var timerDate = this.date.clone();
            var dur = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(timerDate.diff(now));

            switch (value) {
                case 'years':
                    return dur.asYears() >= 1;
                case 'months':
                    return dur.asMonths() >= 1;
                case 'days':
                    return dur.asDays() >= 1;
                case 'hours':
                    return dur.asHours() >= 1;
                case 'minutes':
                    return dur.asMinutes() >= 1;
                case 'seconds':
                    return dur.asSeconds() >= 1;
                default:
                    return dur > 0;
            }
        }
    },
    created: function created() {
        this.timer();
        console.log(this.splitDateTime);
    }
});

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 8,
	"./af.js": 8,
	"./ar": 15,
	"./ar-dz": 9,
	"./ar-dz.js": 9,
	"./ar-kw": 10,
	"./ar-kw.js": 10,
	"./ar-ly": 11,
	"./ar-ly.js": 11,
	"./ar-ma": 12,
	"./ar-ma.js": 12,
	"./ar-sa": 13,
	"./ar-sa.js": 13,
	"./ar-tn": 14,
	"./ar-tn.js": 14,
	"./ar.js": 15,
	"./az": 16,
	"./az.js": 16,
	"./be": 17,
	"./be.js": 17,
	"./bg": 18,
	"./bg.js": 18,
	"./bn": 19,
	"./bn.js": 19,
	"./bo": 20,
	"./bo.js": 20,
	"./br": 21,
	"./br.js": 21,
	"./bs": 22,
	"./bs.js": 22,
	"./ca": 23,
	"./ca.js": 23,
	"./cs": 24,
	"./cs.js": 24,
	"./cv": 25,
	"./cv.js": 25,
	"./cy": 26,
	"./cy.js": 26,
	"./da": 27,
	"./da.js": 27,
	"./de": 30,
	"./de-at": 28,
	"./de-at.js": 28,
	"./de-ch": 29,
	"./de-ch.js": 29,
	"./de.js": 30,
	"./dv": 31,
	"./dv.js": 31,
	"./el": 32,
	"./el.js": 32,
	"./en-au": 33,
	"./en-au.js": 33,
	"./en-ca": 34,
	"./en-ca.js": 34,
	"./en-gb": 35,
	"./en-gb.js": 35,
	"./en-ie": 36,
	"./en-ie.js": 36,
	"./en-nz": 37,
	"./en-nz.js": 37,
	"./eo": 38,
	"./eo.js": 38,
	"./es": 40,
	"./es-do": 39,
	"./es-do.js": 39,
	"./es.js": 40,
	"./et": 41,
	"./et.js": 41,
	"./eu": 42,
	"./eu.js": 42,
	"./fa": 43,
	"./fa.js": 43,
	"./fi": 44,
	"./fi.js": 44,
	"./fo": 45,
	"./fo.js": 45,
	"./fr": 48,
	"./fr-ca": 46,
	"./fr-ca.js": 46,
	"./fr-ch": 47,
	"./fr-ch.js": 47,
	"./fr.js": 48,
	"./fy": 49,
	"./fy.js": 49,
	"./gd": 50,
	"./gd.js": 50,
	"./gl": 51,
	"./gl.js": 51,
	"./gom-latn": 52,
	"./gom-latn.js": 52,
	"./he": 53,
	"./he.js": 53,
	"./hi": 54,
	"./hi.js": 54,
	"./hr": 55,
	"./hr.js": 55,
	"./hu": 56,
	"./hu.js": 56,
	"./hy-am": 57,
	"./hy-am.js": 57,
	"./id": 58,
	"./id.js": 58,
	"./is": 59,
	"./is.js": 59,
	"./it": 60,
	"./it.js": 60,
	"./ja": 61,
	"./ja.js": 61,
	"./jv": 62,
	"./jv.js": 62,
	"./ka": 63,
	"./ka.js": 63,
	"./kk": 64,
	"./kk.js": 64,
	"./km": 65,
	"./km.js": 65,
	"./kn": 66,
	"./kn.js": 66,
	"./ko": 67,
	"./ko.js": 67,
	"./ky": 68,
	"./ky.js": 68,
	"./lb": 69,
	"./lb.js": 69,
	"./lo": 70,
	"./lo.js": 70,
	"./lt": 71,
	"./lt.js": 71,
	"./lv": 72,
	"./lv.js": 72,
	"./me": 73,
	"./me.js": 73,
	"./mi": 74,
	"./mi.js": 74,
	"./mk": 75,
	"./mk.js": 75,
	"./ml": 76,
	"./ml.js": 76,
	"./mr": 77,
	"./mr.js": 77,
	"./ms": 79,
	"./ms-my": 78,
	"./ms-my.js": 78,
	"./ms.js": 79,
	"./my": 80,
	"./my.js": 80,
	"./nb": 81,
	"./nb.js": 81,
	"./ne": 82,
	"./ne.js": 82,
	"./nl": 84,
	"./nl-be": 83,
	"./nl-be.js": 83,
	"./nl.js": 84,
	"./nn": 85,
	"./nn.js": 85,
	"./pa-in": 86,
	"./pa-in.js": 86,
	"./pl": 87,
	"./pl.js": 87,
	"./pt": 89,
	"./pt-br": 88,
	"./pt-br.js": 88,
	"./pt.js": 89,
	"./ro": 90,
	"./ro.js": 90,
	"./ru": 91,
	"./ru.js": 91,
	"./sd": 92,
	"./sd.js": 92,
	"./se": 93,
	"./se.js": 93,
	"./si": 94,
	"./si.js": 94,
	"./sk": 95,
	"./sk.js": 95,
	"./sl": 96,
	"./sl.js": 96,
	"./sq": 97,
	"./sq.js": 97,
	"./sr": 99,
	"./sr-cyrl": 98,
	"./sr-cyrl.js": 98,
	"./sr.js": 99,
	"./ss": 100,
	"./ss.js": 100,
	"./sv": 101,
	"./sv.js": 101,
	"./sw": 102,
	"./sw.js": 102,
	"./ta": 103,
	"./ta.js": 103,
	"./te": 104,
	"./te.js": 104,
	"./tet": 105,
	"./tet.js": 105,
	"./th": 106,
	"./th.js": 106,
	"./tl-ph": 107,
	"./tl-ph.js": 107,
	"./tlh": 108,
	"./tlh.js": 108,
	"./tr": 109,
	"./tr.js": 109,
	"./tzl": 110,
	"./tzl.js": 110,
	"./tzm": 112,
	"./tzm-latn": 111,
	"./tzm-latn.js": 111,
	"./tzm.js": 112,
	"./uk": 113,
	"./uk.js": 113,
	"./ur": 114,
	"./ur.js": 114,
	"./uz": 116,
	"./uz-latn": 115,
	"./uz-latn.js": 115,
	"./uz.js": 116,
	"./vi": 117,
	"./vi.js": 117,
	"./x-pseudo": 118,
	"./x-pseudo.js": 118,
	"./yo": 119,
	"./yo.js": 119,
	"./zh-cn": 120,
	"./zh-cn.js": 120,
	"./zh-hk": 121,
	"./zh-hk.js": 121,
	"./zh-tw": 122,
	"./zh-tw.js": 122
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(150),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22c2a2ed",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(151),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5b72aa00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 150:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      'has-title': _vm.title, 'is-light': _vm.isLight
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.duration) ? _c('div', {
    staticClass: "countdown"
  }, [_c('div', {
    class: [_vm.duration.years ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.duration.years))]), _vm._v(" "), (_vm.duration.years == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Jahr")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Jahre")])]), _vm._v(" "), _c('div', {
    class: [_vm.months ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.months))]), _vm._v(" "), (_vm.months == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Monat")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Monate")])]), _vm._v(" "), _c('div', {
    class: [_vm.days ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.days))]), _vm._v(" "), (_vm.days == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Tag")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Tage")])]), _vm._v(" "), _c('div', {
    class: [_vm.hours ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v(" "), (_vm.hours == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Stunde")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Stunden")])]), _vm._v(" "), _c('div', {
    class: [_vm.minutes ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.minutes))]), _vm._v(" "), (_vm.minutes == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Minute")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Minuten")])]), _vm._v(" "), _c('div', {
    class: [_vm.seconds ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v(" "), (_vm.seconds == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Sekunde")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Sekunden")])])]) : _c('div', {
    staticClass: "expired"
  }, [_c('span', [_vm._v("Der Countdown zum")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.targetDateFormatted))]), _vm._v(" "), _c('span', [_vm._v("ist abgelaufen.")])]), _vm._v(" "), _c('div', {
    staticClass: "debug"
  }, [_vm._v(_vm._s(_vm.resolution) + " | " + _vm._s(_vm.params.datetime))])])
},staticRenderFns: []}

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasDuration()) ? _c('div', {
    staticClass: "countdown"
  }, [(_vm.hasDuration('years')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.years))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('years')) ? _c('span', [_vm._v("Jahre")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('months')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.months))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('months')) ? _c('span', [_vm._v("Monate")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('days')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.days))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('days')) ? _c('span', [_vm._v("Tage")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('hours')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hours))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('hours')) ? _c('span', [_vm._v("Stunden")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('minutes')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.minutes))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('minutes')) ? _c('span', [_vm._v("Minuten")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('seconds')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.seconds))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('seconds')) ? _c('span', [_vm._v("Sekunden")]) : _vm._e()]) : _c('div', {
    staticClass: "expired"
  }, [_c('span', [_vm._v("Der Countdown zum")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateReadable))]), _vm._v(" "), _c('span', [_vm._v("ist abgelaufen.")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.splitDateTime))])])
},staticRenderFns: []}

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ })

},[125]);


// WEBPACK FOOTER //
// static/js/app.362c62e50c259291c649.js